import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicVideoBoxProps {
  children: ReactNode;
  className?: string;
}

const NeumorphicVideoBox = ({ children, className = "" }: NeumorphicVideoBoxProps) => {
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getStyles = () => {
    if (theme === "dark") {
      // Dark mode: remove frame shadow, just use matching background
      return "bg-[#0a0a0a] shadow-none";
    } else {
      // Light mode: use matching background color so frame is invisible
      return "bg-[#f5f5f5] shadow-none";
    }
  };

  return (
    <div className={cn(
      "rounded-3xl overflow-hidden transition-all duration-300",
      getStyles(),
      className
    )}>
      {children}
    </div>
  );
};

export default NeumorphicVideoBox;
